import { useMemo } from 'react';

import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { ChevronDownIcon } from '@heroicons/react/16/solid';
import { LANGUAGES_FLAGS, LanguageFullNameEnum, LanguageEnum } from 'utils/constants';

import LanguageItem from './LanguageItem';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu.tsx';
import { Button } from 'components/ui/button.tsx';
import { cn } from 'utils/utils.ts';

interface LanguageSelectorProps {
  hoverStyle?: string;
}

const LanguageSelector = ({ hoverStyle }: LanguageSelectorProps) => {
  const { i18n } = useTranslation();

  const flagImg = useMemo(() => {
    return LANGUAGES_FLAGS[i18n.language as LanguageEnum];
  }, [i18n.language]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={<Button type='button' variant='ghost' className={cn(hoverStyle ?? 'bg-beige hover:bg-beige/60')} />}
      >
        <div className='flex cursor-pointer items-center gap-[6px]'>
          <img src={flagImg} alt={`${i18n.language} flag`} className='h-[16px] w-[16px] rounded-full' />

          <div className='font-[MuseoSans900] text-base uppercase tracking-[1.5px] text-grey500'>{i18n.language}</div>
        </div>

        <ChevronDownIcon className='size-4 fill-grey500' />
      </DropdownMenuTrigger>

      <DropdownMenuContent className='w-40 border border-beige bg-white ring-0' align='start'>
        <DropdownMenuGroup>
          {_.map(_.keys(LanguageFullNameEnum), (lang: LanguageEnum) => (
            <DropdownMenuItem key={lang}>
              <LanguageItem lang={lang} fullname={_.get(LanguageFullNameEnum, lang)} />
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
